<template>
  <div>
    <v-select
      v-model="selectedForm"
      :options="forms"
      label="name"
    />
  </div>
</template>

<script>
import find from 'lodash-es/find';
export default {
  name: 'CourseBuilderLearningActivity',
  props: ['value'],
  computed: {
    forms () {
      return this.$store.state.learningActivities
    },
    selectedForm: {
      get () {
        return find(this.forms, {id: parseInt(this.value)})
      },
      set (val) {
        this.$emit('input', val.id)
      }
    }
  }
};
</script>

<style scoped>

</style>